import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { JobContactStatistic } from '../models/statistics/job-contact-statistic';
import { JobYearStatistic } from '../models/statistics/job-year-statistic';

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {

  private httpClient = inject(HttpClient);
  private controllerUrl = environment.apiBaseUrl + '/api/' + environment.apiVersion + '/statistics/';

  getJobYears(): Observable<number[]> {
    return this.httpClient.get<number[]>(this.controllerUrl + 'years/');
  }

  getJobYearStatistics(year: number, contactId: number|null): Observable<JobYearStatistic[]> {
    return this.httpClient.get<JobYearStatistic[]>(this.controllerUrl + 'year-statistics/', {
      params: {
        year: year.toString(),
        contactId: contactId ? contactId.toString() : null
      }
    });
  }

  getJobContactStatistics(year: number, month: number, contactId: number|null): Observable<JobContactStatistic[]> {
    return this.httpClient.get<JobContactStatistic[]>(this.controllerUrl + 'contact-statistics/', {
      params: {
        year: year.toString(),
        month: month.toString(),
        contactId: contactId ? contactId.toString() : null,
      }
    });
  }

}
